import { render, staticRenderFns } from "./newJuryEdition.vue?vue&type=template&id=76aace1f"
import script from "./newJuryEdition.vue?vue&type=script&lang=js"
export * from "./newJuryEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports